<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 273.52">
    <circle :fill="color2" cx="108.8" cy="207.52" r="21.76"/>
    <path :fill="color1"
          d="M108.8,0l11.73,22.64L33.77,163.41c-7.62,12.94-12,28.01-12,44.11,0,26,11.4,49.33,29.48,65.28h-29.48C8.1,254.62,0,232.01,0,207.52c0-20.07,5.44-38.86,14.91-55L108.8,0Z"/>
    <path :fill="color1"
          d="M166.37,272.8c18.07-15.95,29.48-39.28,29.48-65.28,0-17.84-5.37-34.43-14.58-48.24l-37.85-52.93,12.04-20.52,44.29,61.95c11.28,17.15,17.85,37.67,17.85,59.73,0,24.49-8.1,47.1-21.76,65.28h-29.48Z"/>
    <path :fill="color1"
          d="M143.65,181.44l-24.69-33.41,11.95-20.36,31.49,42.56h-.01c7.37,10.58,11.7,23.42,11.7,37.28,0,36.05-29.23,65.28-65.28,65.28s-65.28-29.23-65.28-65.28c0-13.94,7.89-31.97,11.82-37.45L131.14,41.21l12.14,22.27-70.78,120.06c-3.11,4.88-7.21,15.12-7.21,23.99,0,24.04,19.49,43.52,43.52,43.52s43.52-19.49,43.52-43.52c0-9.74-3.2-18.73-8.6-25.98"/>
  </svg>
</template>

<script>
export default {
  name: 'LogoNoText',
  props: {
    fillColor: {
      type: String,
    },
    fontColor: {
      type: String,
      default: '#000'
    }
  },
  data() {
    return {
      color1: '#c6beb5',
      color2: '#e30613'
    }
  }
}
</script>

<style scoped>

</style>
